import AlarmClock from './alarm-clock.png'
import Lightning from './lightning.png'

const flashSaleAssets = {
  AlarmClock,
  Lightning,
}

export default flashSaleAssets
